<template>
    <s-modal
        :open="open"
        title="Envoyer des crédits"
        :close="true"
        @close="$emit('close')"
    >
        
        <div style="float:right;margin-bottom: 10px">
            <s-button label="Historique des envoies" @onclick="$emit('histo')" theme="is-primary" />
        </div>
        <div>
        <div class="titleCredit">
            <s-l id="EnvoieCredits">Vous êtes sur le point d'envoyer des crédits. Attention : dès que l'utilisateur les aura accepté vous serez débité du nombre de crédits que vous avez envoyé.</s-l>
        </div>
        <div class="labelSendCredit">
            <s-l id="envoieMail"> Mail de l'utilisateur :</s-l>
        </div>
        <s-input type="text" theme="is-large is-primary" v-model="mailUser" placeholder="Mail de l'utilisateur" /><br/>
      
        <div class="labelSendCredit">
            <s-l id="nbCreditSend">Nombre de crédits à envoyer :</s-l>
        </div>
        <s-input type="number" theme="is-large is-primary" v-model="envoyerCredit" placeholder="Nombre de crédits" />
        {{(this.creditUser - this.creditFree) }}
        <div v-if="(this.creditUser - this.creditFree) -  this.envoyerCredit>=0">
            <s-l id="soldeAfterSendCredit" :v="creditUser - envoyerCredit">Votre solde sera de %v après envoi</s-l>
        </div>
        <div v-if="(this.creditUser - this.creditFree) -  this.envoyerCredit<0" style="color:red">
            Votre solde sera de {{this.envoyerCredit - creditUser}} après envoi
            <br/> - Votre solde doit toujours être au dessus ou égale à 0 crédits après envoi.
            <br/> - Vous ne pouvez pas envoyé de crédits gratuits. Vous avez {{this.creditFree}} de crédits gratuits 
        </div>
        <div class="buttonSendCredit">
            <s-button icon="paper-plane" 
                label="Envoyer" 
                theme="is-success is-large" 
                @onclick="goToSendCredit" 
                :disabled="!validEmail || !validCredit" />
        </div>
        <div class="buttonCancelCredit">
            <s-button icon="undo" label="Annuler" theme="is-warning is-large" @onclick="$emit('close')" />
        </div>
        <waiting :open="openWaiting"/>
        <s-modal :open="openSendOk" :close="true" @close="$emit('close')">
            L'envoie de vos crédits est bien partie. L'utilisateur sera informé, il pourra désormais les accepter. Attention, vous serez débité du nombre de crédits seulement lorsqu'il les aura accepter
        </s-modal>
        
        </div>
    </s-modal>
</template>
<style scoped>
 .labelSendCredit {
        font-size: 14px;
        font-weight: bolder;
        margin-top: 20px;
    }
    .explainMail {
        font-size: 12px;
        font-style: italic;
    }
    .buttonSendCredit {
        float: right;
        margin-top: 10px;
    }
    .buttonCancelCredit {
        float: left;
        margin-top: 10px;
    
    }
    .titleCredit {
        font-size: 14px;
    }
</style>
<script>
import joueur_fct from '@/firebase/joueur'
import firebase from 'firebase/app'
import mail_fct from "@/firebase/mails"
import firebase_api from "@/firebase/firebase_api"
export default {
    props: ["open"],
    watch: {
        open(val) {
            this.mailUser = "";
            this.envoyerCredit= 0;
            this.openSendOk=false;
            if (val)
                this.setCreditUser();
        }
    },
    data() {
        return {
            mailUser: "",
            envoyerCredit: 0,
            openWaiting: false,
            openSendOk: false,
            creditUser: 0,
            creditFree: 0
        }
    },
    computed: {
        validEmail: {
            get() {
                return joueur_fct.object.verifEmail(this.mailUser);
            }
        },
        validCredit: {
            get() {
                if (this.envoyerCredit == 0)
                    return false;
                else {
                    if (isNaN(this.envoyerCredit))
                        return false;
                    else
                        {
                            if ((this.creditUser - this.creditFree) -  this.envoyerCredit < 0)
                                return false;
                            else
                                return true;
                        }     
                    
                }
            }
        }
    },
    methods: {
        setCreditUser() {
            firebase_api.api.getDb().collection("credit").doc( this.$store.getters.getUser.authId).get().then(credit=>{
                if (!credit.empty) {
                    this.creditUser = credit.data().credit;
                    if (typeof(credit.data().free)=="undefined")
                        this.creditFree = 0;
                    else
                        this.creditFree = credit.data().free;
                }
            })
        },
        goToSendCredit() {
           
                this.modalCreditInsuffisant = false;
                const functions = firebase.app().functions('europe-west1');
                const params =  {
                    type: "OFFER",
                    credit: this.envoyerCredit,
                    email: this.mailUser,
                    url: window.location
                }
                this.openWaiting = true;
                functions.httpsCallable("sendCredit")(params).then(res=>{
                    this.openWaiting = false;
                    this.openSendOk = true;
                    var paramsMail= {
                        credit: this.envoyerCredit,
                        displayName: this.$store.getters.getUser.displayName,
                        url: window.location.origin + '/payment'
                    }
                    var sendOffer = true;
                    if (typeof(this.$store.getters.getUser.adminSite)!="undefined")
                        if (this.$store.getters.getUser.adminSite) {
                            sendOffer = false;
                            mail_fct.object.sendEmail(this.mailUser, "SEND_OFFRE_CREDIT", paramsMail);    
                        }   
                    if (sendOffer)
                        mail_fct.object.sendEmail(this.mailUser, "SEND_CREDIT", paramsMail);
                    // on envoie le mail
                    // on dit un message comme quoi c bon
                    // il peut aller les voir dans l'historique
                    // i lpeut les anneuler tant que ca n'a pas été pris
                })
            
        }
    }
}
</script>